/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AppTeamRouteImport } from './routes/_app.team'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppReportsRouteImport } from './routes/_app.reports'
import { Route as AppHomeRouteImport } from './routes/_app.home'
import { Route as AppFollowupsRouteImport } from './routes/_app.followups'
import { Route as AppErpRouteImport } from './routes/_app.erp'
import { Route as AppDealsRouteImport } from './routes/_app.deals'
import { Route as AppCrmRouteImport } from './routes/_app.crm'
import { Route as AppContactsRouteImport } from './routes/_app.contacts'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppAccountsRouteImport } from './routes/_app.accounts'
import { Route as AppTeamIndexRouteImport } from './routes/_app.team.index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app.settings.index'
import { Route as AppReportsIndexRouteImport } from './routes/_app.reports.index'
import { Route as AppFollowupsIndexRouteImport } from './routes/_app.followups.index'
import { Route as AppErpIndexRouteImport } from './routes/_app.erp.index'
import { Route as AppDealsIndexRouteImport } from './routes/_app.deals.index'
import { Route as AppContactsIndexRouteImport } from './routes/_app.contacts.index'
import { Route as AppAccountsIndexRouteImport } from './routes/_app.accounts.index'
import { Route as AppTeamUserIdRouteImport } from './routes/_app.team.$userId'
import { Route as AppSettingsWarehousesRouteImport } from './routes/_app.settings.warehouses'
import { Route as AppSettingsTransportsRouteImport } from './routes/_app.settings.transports'
import { Route as AppSettingsTagsRouteImport } from './routes/_app.settings.tags'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app.settings.security'
import { Route as AppSettingsRolesRouteImport } from './routes/_app.settings.roles'
import { Route as AppSettingsPicklistsRouteImport } from './routes/_app.settings.picklists'
import { Route as AppSettingsGoogleDriveRouteImport } from './routes/_app.settings.google-drive'
import { Route as AppSettingsDriversRouteImport } from './routes/_app.settings.drivers'
import { Route as AppSettingsDataRecoveryRouteImport } from './routes/_app.settings.data-recovery'
import { Route as AppSettingsCustomFieldsRouteImport } from './routes/_app.settings.custom-fields'
import { Route as AppSettingsAuditRouteImport } from './routes/_app.settings.audit'
import { Route as AppReportsUserIdRouteImport } from './routes/_app.reports.$userId'
import { Route as AppFollowupsTrashRouteImport } from './routes/_app.followups.trash'
import { Route as AppErpSettingsRouteImport } from './routes/_app.erp.settings'
import { Route as AppErpOrdersRouteImport } from './routes/_app.erp.orders'
import { Route as AppErpManufacturingRouteImport } from './routes/_app.erp.manufacturing'
import { Route as AppErpInventoryRouteImport } from './routes/_app.erp.inventory'
import { Route as AppErpDispatchesRouteImport } from './routes/_app.erp.dispatches'
import { Route as AppDealsTrashRouteImport } from './routes/_app.deals.trash'
import { Route as AppDealsNewRouteImport } from './routes/_app.deals.new'
import { Route as AppDealsDealIdRouteImport } from './routes/_app.deals.$dealId'
import { Route as AppContactsTrashRouteImport } from './routes/_app.contacts.trash'
import { Route as AppContactsNewRouteImport } from './routes/_app.contacts.new'
import { Route as AppContactsContactIdRouteImport } from './routes/_app.contacts.$contactId'
import { Route as AppAdminTagsRouteImport } from './routes/_app.admin.tags'
import { Route as AppAdminAuditRouteImport } from './routes/_app.admin.audit'
import { Route as AppAccountsTrashRouteImport } from './routes/_app.accounts.trash'
import { Route as AppAccountsNewRouteImport } from './routes/_app.accounts.new'
import { Route as AppAccountsAccountIdRouteImport } from './routes/_app.accounts.$accountId'
import { Route as AppErpSettingsIndexRouteImport } from './routes/_app.erp.settings.index'
import { Route as AppErpRawMaterialsIndexRouteImport } from './routes/_app.erp.raw-materials.index'
import { Route as AppErpProductsIndexRouteImport } from './routes/_app.erp.products.index'
import { Route as AppErpOrdersIndexRouteImport } from './routes/_app.erp.orders.index'
import { Route as AppErpManufacturingIndexRouteImport } from './routes/_app.erp.manufacturing.index'
import { Route as AppErpInventoryIndexRouteImport } from './routes/_app.erp.inventory.index'
import { Route as AppErpDispatchesIndexRouteImport } from './routes/_app.erp.dispatches.index'
import { Route as AppErpSettingsWarehousesRouteImport } from './routes/_app.erp.settings.warehouses'
import { Route as AppErpSettingsTransportsRouteImport } from './routes/_app.erp.settings.transports'
import { Route as AppErpSettingsDriversRouteImport } from './routes/_app.erp.settings.drivers'
import { Route as AppErpRawMaterialsNewRouteImport } from './routes/_app.erp.raw-materials.new'
import { Route as AppErpRawMaterialsRawMaterialIdRouteImport } from './routes/_app.erp.raw-materials.$rawMaterialId'
import { Route as AppErpProductsNewRouteImport } from './routes/_app.erp.products.new'
import { Route as AppErpProductsProductIdRouteImport } from './routes/_app.erp.products.$productId'
import { Route as AppErpOrdersNewRouteImport } from './routes/_app.erp.orders.new'
import { Route as AppErpOrdersOrderIdRouteImport } from './routes/_app.erp.orders.$orderId'
import { Route as AppErpManufacturingNewRouteImport } from './routes/_app.erp.manufacturing.new'
import { Route as AppErpManufacturingJobIdRouteImport } from './routes/_app.erp.manufacturing.$jobId'
import { Route as AppErpInventoryAdjustmentsRouteImport } from './routes/_app.erp.inventory.adjustments'
import { Route as AppErpDispatchesNewRouteImport } from './routes/_app.erp.dispatches.new'
import { Route as AppErpDispatchesDispatchIdRouteImport } from './routes/_app.erp.dispatches.$dispatchId'
import { Route as AppErpDispatchesDispatchIdDeliveriesRouteImport } from './routes/_app.erp.dispatches.$dispatchId.deliveries'

const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppFollowupsRoute = AppFollowupsRouteImport.update({
  id: '/followups',
  path: '/followups',
  getParentRoute: () => AppRoute,
} as any)
const AppErpRoute = AppErpRouteImport.update({
  id: '/erp',
  path: '/erp',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsRoute = AppDealsRouteImport.update({
  id: '/deals',
  path: '/deals',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmRoute = AppCrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsRoute = AppContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsRoute = AppAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamIndexRoute = AppTeamIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTeamRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppReportsRoute,
} as any)
const AppFollowupsIndexRoute = AppFollowupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFollowupsRoute,
} as any)
const AppErpIndexRoute = AppErpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppErpRoute,
} as any)
const AppDealsIndexRoute = AppDealsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDealsRoute,
} as any)
const AppContactsIndexRoute = AppContactsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppAccountsIndexRoute = AppAccountsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountsRoute,
} as any)
const AppTeamUserIdRoute = AppTeamUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AppTeamRoute,
} as any)
const AppSettingsWarehousesRoute = AppSettingsWarehousesRouteImport.update({
  id: '/warehouses',
  path: '/warehouses',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTransportsRoute = AppSettingsTransportsRouteImport.update({
  id: '/transports',
  path: '/transports',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTagsRoute = AppSettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsRolesRoute = AppSettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPicklistsRoute = AppSettingsPicklistsRouteImport.update({
  id: '/picklists',
  path: '/picklists',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsGoogleDriveRoute = AppSettingsGoogleDriveRouteImport.update({
  id: '/google-drive',
  path: '/google-drive',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDriversRoute = AppSettingsDriversRouteImport.update({
  id: '/drivers',
  path: '/drivers',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDataRecoveryRoute = AppSettingsDataRecoveryRouteImport.update({
  id: '/data-recovery',
  path: '/data-recovery',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCustomFieldsRoute = AppSettingsCustomFieldsRouteImport.update({
  id: '/custom-fields',
  path: '/custom-fields',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAuditRoute = AppSettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppReportsUserIdRoute = AppReportsUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AppReportsRoute,
} as any)
const AppFollowupsTrashRoute = AppFollowupsTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppFollowupsRoute,
} as any)
const AppErpSettingsRoute = AppErpSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppErpRoute,
} as any)
const AppErpOrdersRoute = AppErpOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppErpRoute,
} as any)
const AppErpManufacturingRoute = AppErpManufacturingRouteImport.update({
  id: '/manufacturing',
  path: '/manufacturing',
  getParentRoute: () => AppErpRoute,
} as any)
const AppErpInventoryRoute = AppErpInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppErpRoute,
} as any)
const AppErpDispatchesRoute = AppErpDispatchesRouteImport.update({
  id: '/dispatches',
  path: '/dispatches',
  getParentRoute: () => AppErpRoute,
} as any)
const AppDealsTrashRoute = AppDealsTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppDealsRoute,
} as any)
const AppDealsNewRoute = AppDealsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppDealsRoute,
} as any)
const AppDealsDealIdRoute = AppDealsDealIdRouteImport.update({
  id: '/$dealId',
  path: '/$dealId',
  getParentRoute: () => AppDealsRoute,
} as any)
const AppContactsTrashRoute = AppContactsTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppContactsNewRoute = AppContactsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppContactsContactIdRoute = AppContactsContactIdRouteImport.update({
  id: '/$contactId',
  path: '/$contactId',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppAdminTagsRoute = AppAdminTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAccountsTrashRoute = AppAccountsTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppAccountsRoute,
} as any)
const AppAccountsNewRoute = AppAccountsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAccountsRoute,
} as any)
const AppAccountsAccountIdRoute = AppAccountsAccountIdRouteImport.update({
  id: '/$accountId',
  path: '/$accountId',
  getParentRoute: () => AppAccountsRoute,
} as any)
const AppErpSettingsIndexRoute = AppErpSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppErpSettingsRoute,
} as any)
const AppErpRawMaterialsIndexRoute = AppErpRawMaterialsIndexRouteImport.update({
  id: '/raw-materials/',
  path: '/raw-materials/',
  getParentRoute: () => AppErpRoute,
} as any)
const AppErpProductsIndexRoute = AppErpProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppErpRoute,
} as any)
const AppErpOrdersIndexRoute = AppErpOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppErpOrdersRoute,
} as any)
const AppErpManufacturingIndexRoute =
  AppErpManufacturingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppErpManufacturingRoute,
  } as any)
const AppErpInventoryIndexRoute = AppErpInventoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppErpInventoryRoute,
} as any)
const AppErpDispatchesIndexRoute = AppErpDispatchesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppErpDispatchesRoute,
} as any)
const AppErpSettingsWarehousesRoute =
  AppErpSettingsWarehousesRouteImport.update({
    id: '/warehouses',
    path: '/warehouses',
    getParentRoute: () => AppErpSettingsRoute,
  } as any)
const AppErpSettingsTransportsRoute =
  AppErpSettingsTransportsRouteImport.update({
    id: '/transports',
    path: '/transports',
    getParentRoute: () => AppErpSettingsRoute,
  } as any)
const AppErpSettingsDriversRoute = AppErpSettingsDriversRouteImport.update({
  id: '/drivers',
  path: '/drivers',
  getParentRoute: () => AppErpSettingsRoute,
} as any)
const AppErpRawMaterialsNewRoute = AppErpRawMaterialsNewRouteImport.update({
  id: '/raw-materials/new',
  path: '/raw-materials/new',
  getParentRoute: () => AppErpRoute,
} as any)
const AppErpRawMaterialsRawMaterialIdRoute =
  AppErpRawMaterialsRawMaterialIdRouteImport.update({
    id: '/raw-materials/$rawMaterialId',
    path: '/raw-materials/$rawMaterialId',
    getParentRoute: () => AppErpRoute,
  } as any)
const AppErpProductsNewRoute = AppErpProductsNewRouteImport.update({
  id: '/products/new',
  path: '/products/new',
  getParentRoute: () => AppErpRoute,
} as any)
const AppErpProductsProductIdRoute = AppErpProductsProductIdRouteImport.update({
  id: '/products/$productId',
  path: '/products/$productId',
  getParentRoute: () => AppErpRoute,
} as any)
const AppErpOrdersNewRoute = AppErpOrdersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppErpOrdersRoute,
} as any)
const AppErpOrdersOrderIdRoute = AppErpOrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => AppErpOrdersRoute,
} as any)
const AppErpManufacturingNewRoute = AppErpManufacturingNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppErpManufacturingRoute,
} as any)
const AppErpManufacturingJobIdRoute =
  AppErpManufacturingJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => AppErpManufacturingRoute,
  } as any)
const AppErpInventoryAdjustmentsRoute =
  AppErpInventoryAdjustmentsRouteImport.update({
    id: '/adjustments',
    path: '/adjustments',
    getParentRoute: () => AppErpInventoryRoute,
  } as any)
const AppErpDispatchesNewRoute = AppErpDispatchesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppErpDispatchesRoute,
} as any)
const AppErpDispatchesDispatchIdRoute =
  AppErpDispatchesDispatchIdRouteImport.update({
    id: '/$dispatchId',
    path: '/$dispatchId',
    getParentRoute: () => AppErpDispatchesRoute,
  } as any)
const AppErpDispatchesDispatchIdDeliveriesRoute =
  AppErpDispatchesDispatchIdDeliveriesRouteImport.update({
    id: '/deliveries',
    path: '/deliveries',
    getParentRoute: () => AppErpDispatchesDispatchIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/setup': typeof SetupRoute
  '/accounts': typeof AppAccountsRouteWithChildren
  '/admin': typeof AppAdminRouteWithChildren
  '/contacts': typeof AppContactsRouteWithChildren
  '/crm': typeof AppCrmRoute
  '/deals': typeof AppDealsRouteWithChildren
  '/erp': typeof AppErpRouteWithChildren
  '/followups': typeof AppFollowupsRouteWithChildren
  '/home': typeof AppHomeRoute
  '/reports': typeof AppReportsRouteWithChildren
  '/settings': typeof AppSettingsRouteWithChildren
  '/team': typeof AppTeamRouteWithChildren
  '/invite/$token': typeof InviteTokenRoute
  '/accounts/$accountId': typeof AppAccountsAccountIdRoute
  '/accounts/new': typeof AppAccountsNewRoute
  '/accounts/trash': typeof AppAccountsTrashRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/tags': typeof AppAdminTagsRoute
  '/contacts/$contactId': typeof AppContactsContactIdRoute
  '/contacts/new': typeof AppContactsNewRoute
  '/contacts/trash': typeof AppContactsTrashRoute
  '/deals/$dealId': typeof AppDealsDealIdRoute
  '/deals/new': typeof AppDealsNewRoute
  '/deals/trash': typeof AppDealsTrashRoute
  '/erp/dispatches': typeof AppErpDispatchesRouteWithChildren
  '/erp/inventory': typeof AppErpInventoryRouteWithChildren
  '/erp/manufacturing': typeof AppErpManufacturingRouteWithChildren
  '/erp/orders': typeof AppErpOrdersRouteWithChildren
  '/erp/settings': typeof AppErpSettingsRouteWithChildren
  '/followups/trash': typeof AppFollowupsTrashRoute
  '/reports/$userId': typeof AppReportsUserIdRoute
  '/settings/audit': typeof AppSettingsAuditRoute
  '/settings/custom-fields': typeof AppSettingsCustomFieldsRoute
  '/settings/data-recovery': typeof AppSettingsDataRecoveryRoute
  '/settings/drivers': typeof AppSettingsDriversRoute
  '/settings/google-drive': typeof AppSettingsGoogleDriveRoute
  '/settings/picklists': typeof AppSettingsPicklistsRoute
  '/settings/roles': typeof AppSettingsRolesRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/tags': typeof AppSettingsTagsRoute
  '/settings/transports': typeof AppSettingsTransportsRoute
  '/settings/warehouses': typeof AppSettingsWarehousesRoute
  '/team/$userId': typeof AppTeamUserIdRoute
  '/accounts/': typeof AppAccountsIndexRoute
  '/contacts/': typeof AppContactsIndexRoute
  '/deals/': typeof AppDealsIndexRoute
  '/erp/': typeof AppErpIndexRoute
  '/followups/': typeof AppFollowupsIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/team/': typeof AppTeamIndexRoute
  '/erp/dispatches/$dispatchId': typeof AppErpDispatchesDispatchIdRouteWithChildren
  '/erp/dispatches/new': typeof AppErpDispatchesNewRoute
  '/erp/inventory/adjustments': typeof AppErpInventoryAdjustmentsRoute
  '/erp/manufacturing/$jobId': typeof AppErpManufacturingJobIdRoute
  '/erp/manufacturing/new': typeof AppErpManufacturingNewRoute
  '/erp/orders/$orderId': typeof AppErpOrdersOrderIdRoute
  '/erp/orders/new': typeof AppErpOrdersNewRoute
  '/erp/products/$productId': typeof AppErpProductsProductIdRoute
  '/erp/products/new': typeof AppErpProductsNewRoute
  '/erp/raw-materials/$rawMaterialId': typeof AppErpRawMaterialsRawMaterialIdRoute
  '/erp/raw-materials/new': typeof AppErpRawMaterialsNewRoute
  '/erp/settings/drivers': typeof AppErpSettingsDriversRoute
  '/erp/settings/transports': typeof AppErpSettingsTransportsRoute
  '/erp/settings/warehouses': typeof AppErpSettingsWarehousesRoute
  '/erp/dispatches/': typeof AppErpDispatchesIndexRoute
  '/erp/inventory/': typeof AppErpInventoryIndexRoute
  '/erp/manufacturing/': typeof AppErpManufacturingIndexRoute
  '/erp/orders/': typeof AppErpOrdersIndexRoute
  '/erp/products/': typeof AppErpProductsIndexRoute
  '/erp/raw-materials/': typeof AppErpRawMaterialsIndexRoute
  '/erp/settings/': typeof AppErpSettingsIndexRoute
  '/erp/dispatches/$dispatchId/deliveries': typeof AppErpDispatchesDispatchIdDeliveriesRoute
}
export interface FileRoutesByTo {
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/setup': typeof SetupRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/crm': typeof AppCrmRoute
  '/home': typeof AppHomeRoute
  '/invite/$token': typeof InviteTokenRoute
  '/': typeof AppIndexRoute
  '/accounts/$accountId': typeof AppAccountsAccountIdRoute
  '/accounts/new': typeof AppAccountsNewRoute
  '/accounts/trash': typeof AppAccountsTrashRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/tags': typeof AppAdminTagsRoute
  '/contacts/$contactId': typeof AppContactsContactIdRoute
  '/contacts/new': typeof AppContactsNewRoute
  '/contacts/trash': typeof AppContactsTrashRoute
  '/deals/$dealId': typeof AppDealsDealIdRoute
  '/deals/new': typeof AppDealsNewRoute
  '/deals/trash': typeof AppDealsTrashRoute
  '/followups/trash': typeof AppFollowupsTrashRoute
  '/reports/$userId': typeof AppReportsUserIdRoute
  '/settings/audit': typeof AppSettingsAuditRoute
  '/settings/custom-fields': typeof AppSettingsCustomFieldsRoute
  '/settings/data-recovery': typeof AppSettingsDataRecoveryRoute
  '/settings/drivers': typeof AppSettingsDriversRoute
  '/settings/google-drive': typeof AppSettingsGoogleDriveRoute
  '/settings/picklists': typeof AppSettingsPicklistsRoute
  '/settings/roles': typeof AppSettingsRolesRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/tags': typeof AppSettingsTagsRoute
  '/settings/transports': typeof AppSettingsTransportsRoute
  '/settings/warehouses': typeof AppSettingsWarehousesRoute
  '/team/$userId': typeof AppTeamUserIdRoute
  '/accounts': typeof AppAccountsIndexRoute
  '/contacts': typeof AppContactsIndexRoute
  '/deals': typeof AppDealsIndexRoute
  '/erp': typeof AppErpIndexRoute
  '/followups': typeof AppFollowupsIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/team': typeof AppTeamIndexRoute
  '/erp/dispatches/$dispatchId': typeof AppErpDispatchesDispatchIdRouteWithChildren
  '/erp/dispatches/new': typeof AppErpDispatchesNewRoute
  '/erp/inventory/adjustments': typeof AppErpInventoryAdjustmentsRoute
  '/erp/manufacturing/$jobId': typeof AppErpManufacturingJobIdRoute
  '/erp/manufacturing/new': typeof AppErpManufacturingNewRoute
  '/erp/orders/$orderId': typeof AppErpOrdersOrderIdRoute
  '/erp/orders/new': typeof AppErpOrdersNewRoute
  '/erp/products/$productId': typeof AppErpProductsProductIdRoute
  '/erp/products/new': typeof AppErpProductsNewRoute
  '/erp/raw-materials/$rawMaterialId': typeof AppErpRawMaterialsRawMaterialIdRoute
  '/erp/raw-materials/new': typeof AppErpRawMaterialsNewRoute
  '/erp/settings/drivers': typeof AppErpSettingsDriversRoute
  '/erp/settings/transports': typeof AppErpSettingsTransportsRoute
  '/erp/settings/warehouses': typeof AppErpSettingsWarehousesRoute
  '/erp/dispatches': typeof AppErpDispatchesIndexRoute
  '/erp/inventory': typeof AppErpInventoryIndexRoute
  '/erp/manufacturing': typeof AppErpManufacturingIndexRoute
  '/erp/orders': typeof AppErpOrdersIndexRoute
  '/erp/products': typeof AppErpProductsIndexRoute
  '/erp/raw-materials': typeof AppErpRawMaterialsIndexRoute
  '/erp/settings': typeof AppErpSettingsIndexRoute
  '/erp/dispatches/$dispatchId/deliveries': typeof AppErpDispatchesDispatchIdDeliveriesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/setup': typeof SetupRoute
  '/_app/accounts': typeof AppAccountsRouteWithChildren
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/contacts': typeof AppContactsRouteWithChildren
  '/_app/crm': typeof AppCrmRoute
  '/_app/deals': typeof AppDealsRouteWithChildren
  '/_app/erp': typeof AppErpRouteWithChildren
  '/_app/followups': typeof AppFollowupsRouteWithChildren
  '/_app/home': typeof AppHomeRoute
  '/_app/reports': typeof AppReportsRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/team': typeof AppTeamRouteWithChildren
  '/invite/$token': typeof InviteTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/accounts/$accountId': typeof AppAccountsAccountIdRoute
  '/_app/accounts/new': typeof AppAccountsNewRoute
  '/_app/accounts/trash': typeof AppAccountsTrashRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/tags': typeof AppAdminTagsRoute
  '/_app/contacts/$contactId': typeof AppContactsContactIdRoute
  '/_app/contacts/new': typeof AppContactsNewRoute
  '/_app/contacts/trash': typeof AppContactsTrashRoute
  '/_app/deals/$dealId': typeof AppDealsDealIdRoute
  '/_app/deals/new': typeof AppDealsNewRoute
  '/_app/deals/trash': typeof AppDealsTrashRoute
  '/_app/erp/dispatches': typeof AppErpDispatchesRouteWithChildren
  '/_app/erp/inventory': typeof AppErpInventoryRouteWithChildren
  '/_app/erp/manufacturing': typeof AppErpManufacturingRouteWithChildren
  '/_app/erp/orders': typeof AppErpOrdersRouteWithChildren
  '/_app/erp/settings': typeof AppErpSettingsRouteWithChildren
  '/_app/followups/trash': typeof AppFollowupsTrashRoute
  '/_app/reports/$userId': typeof AppReportsUserIdRoute
  '/_app/settings/audit': typeof AppSettingsAuditRoute
  '/_app/settings/custom-fields': typeof AppSettingsCustomFieldsRoute
  '/_app/settings/data-recovery': typeof AppSettingsDataRecoveryRoute
  '/_app/settings/drivers': typeof AppSettingsDriversRoute
  '/_app/settings/google-drive': typeof AppSettingsGoogleDriveRoute
  '/_app/settings/picklists': typeof AppSettingsPicklistsRoute
  '/_app/settings/roles': typeof AppSettingsRolesRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/tags': typeof AppSettingsTagsRoute
  '/_app/settings/transports': typeof AppSettingsTransportsRoute
  '/_app/settings/warehouses': typeof AppSettingsWarehousesRoute
  '/_app/team/$userId': typeof AppTeamUserIdRoute
  '/_app/accounts/': typeof AppAccountsIndexRoute
  '/_app/contacts/': typeof AppContactsIndexRoute
  '/_app/deals/': typeof AppDealsIndexRoute
  '/_app/erp/': typeof AppErpIndexRoute
  '/_app/followups/': typeof AppFollowupsIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/team/': typeof AppTeamIndexRoute
  '/_app/erp/dispatches/$dispatchId': typeof AppErpDispatchesDispatchIdRouteWithChildren
  '/_app/erp/dispatches/new': typeof AppErpDispatchesNewRoute
  '/_app/erp/inventory/adjustments': typeof AppErpInventoryAdjustmentsRoute
  '/_app/erp/manufacturing/$jobId': typeof AppErpManufacturingJobIdRoute
  '/_app/erp/manufacturing/new': typeof AppErpManufacturingNewRoute
  '/_app/erp/orders/$orderId': typeof AppErpOrdersOrderIdRoute
  '/_app/erp/orders/new': typeof AppErpOrdersNewRoute
  '/_app/erp/products/$productId': typeof AppErpProductsProductIdRoute
  '/_app/erp/products/new': typeof AppErpProductsNewRoute
  '/_app/erp/raw-materials/$rawMaterialId': typeof AppErpRawMaterialsRawMaterialIdRoute
  '/_app/erp/raw-materials/new': typeof AppErpRawMaterialsNewRoute
  '/_app/erp/settings/drivers': typeof AppErpSettingsDriversRoute
  '/_app/erp/settings/transports': typeof AppErpSettingsTransportsRoute
  '/_app/erp/settings/warehouses': typeof AppErpSettingsWarehousesRoute
  '/_app/erp/dispatches/': typeof AppErpDispatchesIndexRoute
  '/_app/erp/inventory/': typeof AppErpInventoryIndexRoute
  '/_app/erp/manufacturing/': typeof AppErpManufacturingIndexRoute
  '/_app/erp/orders/': typeof AppErpOrdersIndexRoute
  '/_app/erp/products/': typeof AppErpProductsIndexRoute
  '/_app/erp/raw-materials/': typeof AppErpRawMaterialsIndexRoute
  '/_app/erp/settings/': typeof AppErpSettingsIndexRoute
  '/_app/erp/dispatches/$dispatchId/deliveries': typeof AppErpDispatchesDispatchIdDeliveriesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/forgot-password'
    | '/login'
    | '/password-reset'
    | '/setup'
    | '/accounts'
    | '/admin'
    | '/contacts'
    | '/crm'
    | '/deals'
    | '/erp'
    | '/followups'
    | '/home'
    | '/reports'
    | '/settings'
    | '/team'
    | '/invite/$token'
    | '/accounts/$accountId'
    | '/accounts/new'
    | '/accounts/trash'
    | '/admin/audit'
    | '/admin/tags'
    | '/contacts/$contactId'
    | '/contacts/new'
    | '/contacts/trash'
    | '/deals/$dealId'
    | '/deals/new'
    | '/deals/trash'
    | '/erp/dispatches'
    | '/erp/inventory'
    | '/erp/manufacturing'
    | '/erp/orders'
    | '/erp/settings'
    | '/followups/trash'
    | '/reports/$userId'
    | '/settings/audit'
    | '/settings/custom-fields'
    | '/settings/data-recovery'
    | '/settings/drivers'
    | '/settings/google-drive'
    | '/settings/picklists'
    | '/settings/roles'
    | '/settings/security'
    | '/settings/tags'
    | '/settings/transports'
    | '/settings/warehouses'
    | '/team/$userId'
    | '/accounts/'
    | '/contacts/'
    | '/deals/'
    | '/erp/'
    | '/followups/'
    | '/reports/'
    | '/settings/'
    | '/team/'
    | '/erp/dispatches/$dispatchId'
    | '/erp/dispatches/new'
    | '/erp/inventory/adjustments'
    | '/erp/manufacturing/$jobId'
    | '/erp/manufacturing/new'
    | '/erp/orders/$orderId'
    | '/erp/orders/new'
    | '/erp/products/$productId'
    | '/erp/products/new'
    | '/erp/raw-materials/$rawMaterialId'
    | '/erp/raw-materials/new'
    | '/erp/settings/drivers'
    | '/erp/settings/transports'
    | '/erp/settings/warehouses'
    | '/erp/dispatches/'
    | '/erp/inventory/'
    | '/erp/manufacturing/'
    | '/erp/orders/'
    | '/erp/products/'
    | '/erp/raw-materials/'
    | '/erp/settings/'
    | '/erp/dispatches/$dispatchId/deliveries'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/activate'
    | '/forgot-password'
    | '/login'
    | '/password-reset'
    | '/setup'
    | '/admin'
    | '/crm'
    | '/home'
    | '/invite/$token'
    | '/'
    | '/accounts/$accountId'
    | '/accounts/new'
    | '/accounts/trash'
    | '/admin/audit'
    | '/admin/tags'
    | '/contacts/$contactId'
    | '/contacts/new'
    | '/contacts/trash'
    | '/deals/$dealId'
    | '/deals/new'
    | '/deals/trash'
    | '/followups/trash'
    | '/reports/$userId'
    | '/settings/audit'
    | '/settings/custom-fields'
    | '/settings/data-recovery'
    | '/settings/drivers'
    | '/settings/google-drive'
    | '/settings/picklists'
    | '/settings/roles'
    | '/settings/security'
    | '/settings/tags'
    | '/settings/transports'
    | '/settings/warehouses'
    | '/team/$userId'
    | '/accounts'
    | '/contacts'
    | '/deals'
    | '/erp'
    | '/followups'
    | '/reports'
    | '/settings'
    | '/team'
    | '/erp/dispatches/$dispatchId'
    | '/erp/dispatches/new'
    | '/erp/inventory/adjustments'
    | '/erp/manufacturing/$jobId'
    | '/erp/manufacturing/new'
    | '/erp/orders/$orderId'
    | '/erp/orders/new'
    | '/erp/products/$productId'
    | '/erp/products/new'
    | '/erp/raw-materials/$rawMaterialId'
    | '/erp/raw-materials/new'
    | '/erp/settings/drivers'
    | '/erp/settings/transports'
    | '/erp/settings/warehouses'
    | '/erp/dispatches'
    | '/erp/inventory'
    | '/erp/manufacturing'
    | '/erp/orders'
    | '/erp/products'
    | '/erp/raw-materials'
    | '/erp/settings'
    | '/erp/dispatches/$dispatchId/deliveries'
  id:
    | '__root__'
    | '/_app'
    | '/activate'
    | '/forgot-password'
    | '/login'
    | '/password-reset'
    | '/setup'
    | '/_app/accounts'
    | '/_app/admin'
    | '/_app/contacts'
    | '/_app/crm'
    | '/_app/deals'
    | '/_app/erp'
    | '/_app/followups'
    | '/_app/home'
    | '/_app/reports'
    | '/_app/settings'
    | '/_app/team'
    | '/invite/$token'
    | '/_app/'
    | '/_app/accounts/$accountId'
    | '/_app/accounts/new'
    | '/_app/accounts/trash'
    | '/_app/admin/audit'
    | '/_app/admin/tags'
    | '/_app/contacts/$contactId'
    | '/_app/contacts/new'
    | '/_app/contacts/trash'
    | '/_app/deals/$dealId'
    | '/_app/deals/new'
    | '/_app/deals/trash'
    | '/_app/erp/dispatches'
    | '/_app/erp/inventory'
    | '/_app/erp/manufacturing'
    | '/_app/erp/orders'
    | '/_app/erp/settings'
    | '/_app/followups/trash'
    | '/_app/reports/$userId'
    | '/_app/settings/audit'
    | '/_app/settings/custom-fields'
    | '/_app/settings/data-recovery'
    | '/_app/settings/drivers'
    | '/_app/settings/google-drive'
    | '/_app/settings/picklists'
    | '/_app/settings/roles'
    | '/_app/settings/security'
    | '/_app/settings/tags'
    | '/_app/settings/transports'
    | '/_app/settings/warehouses'
    | '/_app/team/$userId'
    | '/_app/accounts/'
    | '/_app/contacts/'
    | '/_app/deals/'
    | '/_app/erp/'
    | '/_app/followups/'
    | '/_app/reports/'
    | '/_app/settings/'
    | '/_app/team/'
    | '/_app/erp/dispatches/$dispatchId'
    | '/_app/erp/dispatches/new'
    | '/_app/erp/inventory/adjustments'
    | '/_app/erp/manufacturing/$jobId'
    | '/_app/erp/manufacturing/new'
    | '/_app/erp/orders/$orderId'
    | '/_app/erp/orders/new'
    | '/_app/erp/products/$productId'
    | '/_app/erp/products/new'
    | '/_app/erp/raw-materials/$rawMaterialId'
    | '/_app/erp/raw-materials/new'
    | '/_app/erp/settings/drivers'
    | '/_app/erp/settings/transports'
    | '/_app/erp/settings/warehouses'
    | '/_app/erp/dispatches/'
    | '/_app/erp/inventory/'
    | '/_app/erp/manufacturing/'
    | '/_app/erp/orders/'
    | '/_app/erp/products/'
    | '/_app/erp/raw-materials/'
    | '/_app/erp/settings/'
    | '/_app/erp/dispatches/$dispatchId/deliveries'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PasswordResetRoute: typeof PasswordResetRoute
  SetupRoute: typeof SetupRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/followups': {
      id: '/_app/followups'
      path: '/followups'
      fullPath: '/followups'
      preLoaderRoute: typeof AppFollowupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/erp': {
      id: '/_app/erp'
      path: '/erp'
      fullPath: '/erp'
      preLoaderRoute: typeof AppErpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals': {
      id: '/_app/deals'
      path: '/deals'
      fullPath: '/deals'
      preLoaderRoute: typeof AppDealsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crm': {
      id: '/_app/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof AppCrmRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts': {
      id: '/_app/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AppContactsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounts': {
      id: '/_app/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AppAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team/': {
      id: '/_app/team/'
      path: '/'
      fullPath: '/team/'
      preLoaderRoute: typeof AppTeamIndexRouteImport
      parentRoute: typeof AppTeamRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppReportsRoute
    }
    '/_app/followups/': {
      id: '/_app/followups/'
      path: '/'
      fullPath: '/followups/'
      preLoaderRoute: typeof AppFollowupsIndexRouteImport
      parentRoute: typeof AppFollowupsRoute
    }
    '/_app/erp/': {
      id: '/_app/erp/'
      path: '/'
      fullPath: '/erp/'
      preLoaderRoute: typeof AppErpIndexRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/deals/': {
      id: '/_app/deals/'
      path: '/'
      fullPath: '/deals/'
      preLoaderRoute: typeof AppDealsIndexRouteImport
      parentRoute: typeof AppDealsRoute
    }
    '/_app/contacts/': {
      id: '/_app/contacts/'
      path: '/'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AppContactsIndexRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/accounts/': {
      id: '/_app/accounts/'
      path: '/'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AppAccountsIndexRouteImport
      parentRoute: typeof AppAccountsRoute
    }
    '/_app/team/$userId': {
      id: '/_app/team/$userId'
      path: '/$userId'
      fullPath: '/team/$userId'
      preLoaderRoute: typeof AppTeamUserIdRouteImport
      parentRoute: typeof AppTeamRoute
    }
    '/_app/settings/warehouses': {
      id: '/_app/settings/warehouses'
      path: '/warehouses'
      fullPath: '/settings/warehouses'
      preLoaderRoute: typeof AppSettingsWarehousesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/transports': {
      id: '/_app/settings/transports'
      path: '/transports'
      fullPath: '/settings/transports'
      preLoaderRoute: typeof AppSettingsTransportsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/tags': {
      id: '/_app/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AppSettingsTagsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/roles': {
      id: '/_app/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AppSettingsRolesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/picklists': {
      id: '/_app/settings/picklists'
      path: '/picklists'
      fullPath: '/settings/picklists'
      preLoaderRoute: typeof AppSettingsPicklistsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/google-drive': {
      id: '/_app/settings/google-drive'
      path: '/google-drive'
      fullPath: '/settings/google-drive'
      preLoaderRoute: typeof AppSettingsGoogleDriveRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/drivers': {
      id: '/_app/settings/drivers'
      path: '/drivers'
      fullPath: '/settings/drivers'
      preLoaderRoute: typeof AppSettingsDriversRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/data-recovery': {
      id: '/_app/settings/data-recovery'
      path: '/data-recovery'
      fullPath: '/settings/data-recovery'
      preLoaderRoute: typeof AppSettingsDataRecoveryRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/custom-fields': {
      id: '/_app/settings/custom-fields'
      path: '/custom-fields'
      fullPath: '/settings/custom-fields'
      preLoaderRoute: typeof AppSettingsCustomFieldsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/audit': {
      id: '/_app/settings/audit'
      path: '/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof AppSettingsAuditRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/reports/$userId': {
      id: '/_app/reports/$userId'
      path: '/$userId'
      fullPath: '/reports/$userId'
      preLoaderRoute: typeof AppReportsUserIdRouteImport
      parentRoute: typeof AppReportsRoute
    }
    '/_app/followups/trash': {
      id: '/_app/followups/trash'
      path: '/trash'
      fullPath: '/followups/trash'
      preLoaderRoute: typeof AppFollowupsTrashRouteImport
      parentRoute: typeof AppFollowupsRoute
    }
    '/_app/erp/settings': {
      id: '/_app/erp/settings'
      path: '/settings'
      fullPath: '/erp/settings'
      preLoaderRoute: typeof AppErpSettingsRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/erp/orders': {
      id: '/_app/erp/orders'
      path: '/orders'
      fullPath: '/erp/orders'
      preLoaderRoute: typeof AppErpOrdersRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/erp/manufacturing': {
      id: '/_app/erp/manufacturing'
      path: '/manufacturing'
      fullPath: '/erp/manufacturing'
      preLoaderRoute: typeof AppErpManufacturingRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/erp/inventory': {
      id: '/_app/erp/inventory'
      path: '/inventory'
      fullPath: '/erp/inventory'
      preLoaderRoute: typeof AppErpInventoryRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/erp/dispatches': {
      id: '/_app/erp/dispatches'
      path: '/dispatches'
      fullPath: '/erp/dispatches'
      preLoaderRoute: typeof AppErpDispatchesRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/deals/trash': {
      id: '/_app/deals/trash'
      path: '/trash'
      fullPath: '/deals/trash'
      preLoaderRoute: typeof AppDealsTrashRouteImport
      parentRoute: typeof AppDealsRoute
    }
    '/_app/deals/new': {
      id: '/_app/deals/new'
      path: '/new'
      fullPath: '/deals/new'
      preLoaderRoute: typeof AppDealsNewRouteImport
      parentRoute: typeof AppDealsRoute
    }
    '/_app/deals/$dealId': {
      id: '/_app/deals/$dealId'
      path: '/$dealId'
      fullPath: '/deals/$dealId'
      preLoaderRoute: typeof AppDealsDealIdRouteImport
      parentRoute: typeof AppDealsRoute
    }
    '/_app/contacts/trash': {
      id: '/_app/contacts/trash'
      path: '/trash'
      fullPath: '/contacts/trash'
      preLoaderRoute: typeof AppContactsTrashRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/contacts/new': {
      id: '/_app/contacts/new'
      path: '/new'
      fullPath: '/contacts/new'
      preLoaderRoute: typeof AppContactsNewRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/contacts/$contactId': {
      id: '/_app/contacts/$contactId'
      path: '/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AppContactsContactIdRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/admin/tags': {
      id: '/_app/admin/tags'
      path: '/tags'
      fullPath: '/admin/tags'
      preLoaderRoute: typeof AppAdminTagsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/accounts/trash': {
      id: '/_app/accounts/trash'
      path: '/trash'
      fullPath: '/accounts/trash'
      preLoaderRoute: typeof AppAccountsTrashRouteImport
      parentRoute: typeof AppAccountsRoute
    }
    '/_app/accounts/new': {
      id: '/_app/accounts/new'
      path: '/new'
      fullPath: '/accounts/new'
      preLoaderRoute: typeof AppAccountsNewRouteImport
      parentRoute: typeof AppAccountsRoute
    }
    '/_app/accounts/$accountId': {
      id: '/_app/accounts/$accountId'
      path: '/$accountId'
      fullPath: '/accounts/$accountId'
      preLoaderRoute: typeof AppAccountsAccountIdRouteImport
      parentRoute: typeof AppAccountsRoute
    }
    '/_app/erp/settings/': {
      id: '/_app/erp/settings/'
      path: '/'
      fullPath: '/erp/settings/'
      preLoaderRoute: typeof AppErpSettingsIndexRouteImport
      parentRoute: typeof AppErpSettingsRoute
    }
    '/_app/erp/raw-materials/': {
      id: '/_app/erp/raw-materials/'
      path: '/raw-materials'
      fullPath: '/erp/raw-materials/'
      preLoaderRoute: typeof AppErpRawMaterialsIndexRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/erp/products/': {
      id: '/_app/erp/products/'
      path: '/products'
      fullPath: '/erp/products/'
      preLoaderRoute: typeof AppErpProductsIndexRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/erp/orders/': {
      id: '/_app/erp/orders/'
      path: '/'
      fullPath: '/erp/orders/'
      preLoaderRoute: typeof AppErpOrdersIndexRouteImport
      parentRoute: typeof AppErpOrdersRoute
    }
    '/_app/erp/manufacturing/': {
      id: '/_app/erp/manufacturing/'
      path: '/'
      fullPath: '/erp/manufacturing/'
      preLoaderRoute: typeof AppErpManufacturingIndexRouteImport
      parentRoute: typeof AppErpManufacturingRoute
    }
    '/_app/erp/inventory/': {
      id: '/_app/erp/inventory/'
      path: '/'
      fullPath: '/erp/inventory/'
      preLoaderRoute: typeof AppErpInventoryIndexRouteImport
      parentRoute: typeof AppErpInventoryRoute
    }
    '/_app/erp/dispatches/': {
      id: '/_app/erp/dispatches/'
      path: '/'
      fullPath: '/erp/dispatches/'
      preLoaderRoute: typeof AppErpDispatchesIndexRouteImport
      parentRoute: typeof AppErpDispatchesRoute
    }
    '/_app/erp/settings/warehouses': {
      id: '/_app/erp/settings/warehouses'
      path: '/warehouses'
      fullPath: '/erp/settings/warehouses'
      preLoaderRoute: typeof AppErpSettingsWarehousesRouteImport
      parentRoute: typeof AppErpSettingsRoute
    }
    '/_app/erp/settings/transports': {
      id: '/_app/erp/settings/transports'
      path: '/transports'
      fullPath: '/erp/settings/transports'
      preLoaderRoute: typeof AppErpSettingsTransportsRouteImport
      parentRoute: typeof AppErpSettingsRoute
    }
    '/_app/erp/settings/drivers': {
      id: '/_app/erp/settings/drivers'
      path: '/drivers'
      fullPath: '/erp/settings/drivers'
      preLoaderRoute: typeof AppErpSettingsDriversRouteImport
      parentRoute: typeof AppErpSettingsRoute
    }
    '/_app/erp/raw-materials/new': {
      id: '/_app/erp/raw-materials/new'
      path: '/raw-materials/new'
      fullPath: '/erp/raw-materials/new'
      preLoaderRoute: typeof AppErpRawMaterialsNewRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/erp/raw-materials/$rawMaterialId': {
      id: '/_app/erp/raw-materials/$rawMaterialId'
      path: '/raw-materials/$rawMaterialId'
      fullPath: '/erp/raw-materials/$rawMaterialId'
      preLoaderRoute: typeof AppErpRawMaterialsRawMaterialIdRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/erp/products/new': {
      id: '/_app/erp/products/new'
      path: '/products/new'
      fullPath: '/erp/products/new'
      preLoaderRoute: typeof AppErpProductsNewRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/erp/products/$productId': {
      id: '/_app/erp/products/$productId'
      path: '/products/$productId'
      fullPath: '/erp/products/$productId'
      preLoaderRoute: typeof AppErpProductsProductIdRouteImport
      parentRoute: typeof AppErpRoute
    }
    '/_app/erp/orders/new': {
      id: '/_app/erp/orders/new'
      path: '/new'
      fullPath: '/erp/orders/new'
      preLoaderRoute: typeof AppErpOrdersNewRouteImport
      parentRoute: typeof AppErpOrdersRoute
    }
    '/_app/erp/orders/$orderId': {
      id: '/_app/erp/orders/$orderId'
      path: '/$orderId'
      fullPath: '/erp/orders/$orderId'
      preLoaderRoute: typeof AppErpOrdersOrderIdRouteImport
      parentRoute: typeof AppErpOrdersRoute
    }
    '/_app/erp/manufacturing/new': {
      id: '/_app/erp/manufacturing/new'
      path: '/new'
      fullPath: '/erp/manufacturing/new'
      preLoaderRoute: typeof AppErpManufacturingNewRouteImport
      parentRoute: typeof AppErpManufacturingRoute
    }
    '/_app/erp/manufacturing/$jobId': {
      id: '/_app/erp/manufacturing/$jobId'
      path: '/$jobId'
      fullPath: '/erp/manufacturing/$jobId'
      preLoaderRoute: typeof AppErpManufacturingJobIdRouteImport
      parentRoute: typeof AppErpManufacturingRoute
    }
    '/_app/erp/inventory/adjustments': {
      id: '/_app/erp/inventory/adjustments'
      path: '/adjustments'
      fullPath: '/erp/inventory/adjustments'
      preLoaderRoute: typeof AppErpInventoryAdjustmentsRouteImport
      parentRoute: typeof AppErpInventoryRoute
    }
    '/_app/erp/dispatches/new': {
      id: '/_app/erp/dispatches/new'
      path: '/new'
      fullPath: '/erp/dispatches/new'
      preLoaderRoute: typeof AppErpDispatchesNewRouteImport
      parentRoute: typeof AppErpDispatchesRoute
    }
    '/_app/erp/dispatches/$dispatchId': {
      id: '/_app/erp/dispatches/$dispatchId'
      path: '/$dispatchId'
      fullPath: '/erp/dispatches/$dispatchId'
      preLoaderRoute: typeof AppErpDispatchesDispatchIdRouteImport
      parentRoute: typeof AppErpDispatchesRoute
    }
    '/_app/erp/dispatches/$dispatchId/deliveries': {
      id: '/_app/erp/dispatches/$dispatchId/deliveries'
      path: '/deliveries'
      fullPath: '/erp/dispatches/$dispatchId/deliveries'
      preLoaderRoute: typeof AppErpDispatchesDispatchIdDeliveriesRouteImport
      parentRoute: typeof AppErpDispatchesDispatchIdRoute
    }
  }
}

interface AppAccountsRouteChildren {
  AppAccountsAccountIdRoute: typeof AppAccountsAccountIdRoute
  AppAccountsNewRoute: typeof AppAccountsNewRoute
  AppAccountsTrashRoute: typeof AppAccountsTrashRoute
  AppAccountsIndexRoute: typeof AppAccountsIndexRoute
}

const AppAccountsRouteChildren: AppAccountsRouteChildren = {
  AppAccountsAccountIdRoute: AppAccountsAccountIdRoute,
  AppAccountsNewRoute: AppAccountsNewRoute,
  AppAccountsTrashRoute: AppAccountsTrashRoute,
  AppAccountsIndexRoute: AppAccountsIndexRoute,
}

const AppAccountsRouteWithChildren = AppAccountsRoute._addFileChildren(
  AppAccountsRouteChildren,
)

interface AppAdminRouteChildren {
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminTagsRoute: typeof AppAdminTagsRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminTagsRoute: AppAdminTagsRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppContactsRouteChildren {
  AppContactsContactIdRoute: typeof AppContactsContactIdRoute
  AppContactsNewRoute: typeof AppContactsNewRoute
  AppContactsTrashRoute: typeof AppContactsTrashRoute
  AppContactsIndexRoute: typeof AppContactsIndexRoute
}

const AppContactsRouteChildren: AppContactsRouteChildren = {
  AppContactsContactIdRoute: AppContactsContactIdRoute,
  AppContactsNewRoute: AppContactsNewRoute,
  AppContactsTrashRoute: AppContactsTrashRoute,
  AppContactsIndexRoute: AppContactsIndexRoute,
}

const AppContactsRouteWithChildren = AppContactsRoute._addFileChildren(
  AppContactsRouteChildren,
)

interface AppDealsRouteChildren {
  AppDealsDealIdRoute: typeof AppDealsDealIdRoute
  AppDealsNewRoute: typeof AppDealsNewRoute
  AppDealsTrashRoute: typeof AppDealsTrashRoute
  AppDealsIndexRoute: typeof AppDealsIndexRoute
}

const AppDealsRouteChildren: AppDealsRouteChildren = {
  AppDealsDealIdRoute: AppDealsDealIdRoute,
  AppDealsNewRoute: AppDealsNewRoute,
  AppDealsTrashRoute: AppDealsTrashRoute,
  AppDealsIndexRoute: AppDealsIndexRoute,
}

const AppDealsRouteWithChildren = AppDealsRoute._addFileChildren(
  AppDealsRouteChildren,
)

interface AppErpDispatchesDispatchIdRouteChildren {
  AppErpDispatchesDispatchIdDeliveriesRoute: typeof AppErpDispatchesDispatchIdDeliveriesRoute
}

const AppErpDispatchesDispatchIdRouteChildren: AppErpDispatchesDispatchIdRouteChildren =
  {
    AppErpDispatchesDispatchIdDeliveriesRoute:
      AppErpDispatchesDispatchIdDeliveriesRoute,
  }

const AppErpDispatchesDispatchIdRouteWithChildren =
  AppErpDispatchesDispatchIdRoute._addFileChildren(
    AppErpDispatchesDispatchIdRouteChildren,
  )

interface AppErpDispatchesRouteChildren {
  AppErpDispatchesDispatchIdRoute: typeof AppErpDispatchesDispatchIdRouteWithChildren
  AppErpDispatchesNewRoute: typeof AppErpDispatchesNewRoute
  AppErpDispatchesIndexRoute: typeof AppErpDispatchesIndexRoute
}

const AppErpDispatchesRouteChildren: AppErpDispatchesRouteChildren = {
  AppErpDispatchesDispatchIdRoute: AppErpDispatchesDispatchIdRouteWithChildren,
  AppErpDispatchesNewRoute: AppErpDispatchesNewRoute,
  AppErpDispatchesIndexRoute: AppErpDispatchesIndexRoute,
}

const AppErpDispatchesRouteWithChildren =
  AppErpDispatchesRoute._addFileChildren(AppErpDispatchesRouteChildren)

interface AppErpInventoryRouteChildren {
  AppErpInventoryAdjustmentsRoute: typeof AppErpInventoryAdjustmentsRoute
  AppErpInventoryIndexRoute: typeof AppErpInventoryIndexRoute
}

const AppErpInventoryRouteChildren: AppErpInventoryRouteChildren = {
  AppErpInventoryAdjustmentsRoute: AppErpInventoryAdjustmentsRoute,
  AppErpInventoryIndexRoute: AppErpInventoryIndexRoute,
}

const AppErpInventoryRouteWithChildren = AppErpInventoryRoute._addFileChildren(
  AppErpInventoryRouteChildren,
)

interface AppErpManufacturingRouteChildren {
  AppErpManufacturingJobIdRoute: typeof AppErpManufacturingJobIdRoute
  AppErpManufacturingNewRoute: typeof AppErpManufacturingNewRoute
  AppErpManufacturingIndexRoute: typeof AppErpManufacturingIndexRoute
}

const AppErpManufacturingRouteChildren: AppErpManufacturingRouteChildren = {
  AppErpManufacturingJobIdRoute: AppErpManufacturingJobIdRoute,
  AppErpManufacturingNewRoute: AppErpManufacturingNewRoute,
  AppErpManufacturingIndexRoute: AppErpManufacturingIndexRoute,
}

const AppErpManufacturingRouteWithChildren =
  AppErpManufacturingRoute._addFileChildren(AppErpManufacturingRouteChildren)

interface AppErpOrdersRouteChildren {
  AppErpOrdersOrderIdRoute: typeof AppErpOrdersOrderIdRoute
  AppErpOrdersNewRoute: typeof AppErpOrdersNewRoute
  AppErpOrdersIndexRoute: typeof AppErpOrdersIndexRoute
}

const AppErpOrdersRouteChildren: AppErpOrdersRouteChildren = {
  AppErpOrdersOrderIdRoute: AppErpOrdersOrderIdRoute,
  AppErpOrdersNewRoute: AppErpOrdersNewRoute,
  AppErpOrdersIndexRoute: AppErpOrdersIndexRoute,
}

const AppErpOrdersRouteWithChildren = AppErpOrdersRoute._addFileChildren(
  AppErpOrdersRouteChildren,
)

interface AppErpSettingsRouteChildren {
  AppErpSettingsDriversRoute: typeof AppErpSettingsDriversRoute
  AppErpSettingsTransportsRoute: typeof AppErpSettingsTransportsRoute
  AppErpSettingsWarehousesRoute: typeof AppErpSettingsWarehousesRoute
  AppErpSettingsIndexRoute: typeof AppErpSettingsIndexRoute
}

const AppErpSettingsRouteChildren: AppErpSettingsRouteChildren = {
  AppErpSettingsDriversRoute: AppErpSettingsDriversRoute,
  AppErpSettingsTransportsRoute: AppErpSettingsTransportsRoute,
  AppErpSettingsWarehousesRoute: AppErpSettingsWarehousesRoute,
  AppErpSettingsIndexRoute: AppErpSettingsIndexRoute,
}

const AppErpSettingsRouteWithChildren = AppErpSettingsRoute._addFileChildren(
  AppErpSettingsRouteChildren,
)

interface AppErpRouteChildren {
  AppErpDispatchesRoute: typeof AppErpDispatchesRouteWithChildren
  AppErpInventoryRoute: typeof AppErpInventoryRouteWithChildren
  AppErpManufacturingRoute: typeof AppErpManufacturingRouteWithChildren
  AppErpOrdersRoute: typeof AppErpOrdersRouteWithChildren
  AppErpSettingsRoute: typeof AppErpSettingsRouteWithChildren
  AppErpIndexRoute: typeof AppErpIndexRoute
  AppErpProductsProductIdRoute: typeof AppErpProductsProductIdRoute
  AppErpProductsNewRoute: typeof AppErpProductsNewRoute
  AppErpRawMaterialsRawMaterialIdRoute: typeof AppErpRawMaterialsRawMaterialIdRoute
  AppErpRawMaterialsNewRoute: typeof AppErpRawMaterialsNewRoute
  AppErpProductsIndexRoute: typeof AppErpProductsIndexRoute
  AppErpRawMaterialsIndexRoute: typeof AppErpRawMaterialsIndexRoute
}

const AppErpRouteChildren: AppErpRouteChildren = {
  AppErpDispatchesRoute: AppErpDispatchesRouteWithChildren,
  AppErpInventoryRoute: AppErpInventoryRouteWithChildren,
  AppErpManufacturingRoute: AppErpManufacturingRouteWithChildren,
  AppErpOrdersRoute: AppErpOrdersRouteWithChildren,
  AppErpSettingsRoute: AppErpSettingsRouteWithChildren,
  AppErpIndexRoute: AppErpIndexRoute,
  AppErpProductsProductIdRoute: AppErpProductsProductIdRoute,
  AppErpProductsNewRoute: AppErpProductsNewRoute,
  AppErpRawMaterialsRawMaterialIdRoute: AppErpRawMaterialsRawMaterialIdRoute,
  AppErpRawMaterialsNewRoute: AppErpRawMaterialsNewRoute,
  AppErpProductsIndexRoute: AppErpProductsIndexRoute,
  AppErpRawMaterialsIndexRoute: AppErpRawMaterialsIndexRoute,
}

const AppErpRouteWithChildren =
  AppErpRoute._addFileChildren(AppErpRouteChildren)

interface AppFollowupsRouteChildren {
  AppFollowupsTrashRoute: typeof AppFollowupsTrashRoute
  AppFollowupsIndexRoute: typeof AppFollowupsIndexRoute
}

const AppFollowupsRouteChildren: AppFollowupsRouteChildren = {
  AppFollowupsTrashRoute: AppFollowupsTrashRoute,
  AppFollowupsIndexRoute: AppFollowupsIndexRoute,
}

const AppFollowupsRouteWithChildren = AppFollowupsRoute._addFileChildren(
  AppFollowupsRouteChildren,
)

interface AppReportsRouteChildren {
  AppReportsUserIdRoute: typeof AppReportsUserIdRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
}

const AppReportsRouteChildren: AppReportsRouteChildren = {
  AppReportsUserIdRoute: AppReportsUserIdRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
}

const AppReportsRouteWithChildren = AppReportsRoute._addFileChildren(
  AppReportsRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsAuditRoute: typeof AppSettingsAuditRoute
  AppSettingsCustomFieldsRoute: typeof AppSettingsCustomFieldsRoute
  AppSettingsDataRecoveryRoute: typeof AppSettingsDataRecoveryRoute
  AppSettingsDriversRoute: typeof AppSettingsDriversRoute
  AppSettingsGoogleDriveRoute: typeof AppSettingsGoogleDriveRoute
  AppSettingsPicklistsRoute: typeof AppSettingsPicklistsRoute
  AppSettingsRolesRoute: typeof AppSettingsRolesRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsTagsRoute: typeof AppSettingsTagsRoute
  AppSettingsTransportsRoute: typeof AppSettingsTransportsRoute
  AppSettingsWarehousesRoute: typeof AppSettingsWarehousesRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAuditRoute: AppSettingsAuditRoute,
  AppSettingsCustomFieldsRoute: AppSettingsCustomFieldsRoute,
  AppSettingsDataRecoveryRoute: AppSettingsDataRecoveryRoute,
  AppSettingsDriversRoute: AppSettingsDriversRoute,
  AppSettingsGoogleDriveRoute: AppSettingsGoogleDriveRoute,
  AppSettingsPicklistsRoute: AppSettingsPicklistsRoute,
  AppSettingsRolesRoute: AppSettingsRolesRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsTagsRoute: AppSettingsTagsRoute,
  AppSettingsTransportsRoute: AppSettingsTransportsRoute,
  AppSettingsWarehousesRoute: AppSettingsWarehousesRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppTeamRouteChildren {
  AppTeamUserIdRoute: typeof AppTeamUserIdRoute
  AppTeamIndexRoute: typeof AppTeamIndexRoute
}

const AppTeamRouteChildren: AppTeamRouteChildren = {
  AppTeamUserIdRoute: AppTeamUserIdRoute,
  AppTeamIndexRoute: AppTeamIndexRoute,
}

const AppTeamRouteWithChildren =
  AppTeamRoute._addFileChildren(AppTeamRouteChildren)

interface AppRouteChildren {
  AppAccountsRoute: typeof AppAccountsRouteWithChildren
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppContactsRoute: typeof AppContactsRouteWithChildren
  AppCrmRoute: typeof AppCrmRoute
  AppDealsRoute: typeof AppDealsRouteWithChildren
  AppErpRoute: typeof AppErpRouteWithChildren
  AppFollowupsRoute: typeof AppFollowupsRouteWithChildren
  AppHomeRoute: typeof AppHomeRoute
  AppReportsRoute: typeof AppReportsRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTeamRoute: typeof AppTeamRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountsRoute: AppAccountsRouteWithChildren,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppContactsRoute: AppContactsRouteWithChildren,
  AppCrmRoute: AppCrmRoute,
  AppDealsRoute: AppDealsRouteWithChildren,
  AppErpRoute: AppErpRouteWithChildren,
  AppFollowupsRoute: AppFollowupsRouteWithChildren,
  AppHomeRoute: AppHomeRoute,
  AppReportsRoute: AppReportsRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTeamRoute: AppTeamRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ActivateRoute: ActivateRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PasswordResetRoute: PasswordResetRoute,
  SetupRoute: SetupRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
